import { useState, useRef, useEffect } from 'react';

const initialState = {
	isLoading: false,
	fadeIn: false,
	collapse: false
};
export const useVehiclesState = () => {
	const [vehiclesState, setVehiclesState] = useState(initialState);
	const isMounted = useRef(false);
	const fadeOutTimeout = useRef();
	const collapseTimeout = useRef();

	useEffect(() => {
		isMounted.current = true;
		return () => {
			isMounted.current = false;
			if (fadeOutTimeout.current) clearTimeout(fadeOutTimeout.current);
			if (collapseTimeout.current) clearTimeout(collapseTimeout.current);
		};
	}, []);

	const startFadeIn = () => {
		if (!isMounted.current) return;
		// If we set fade in as true, means that we started loading the vehicles
		setVehiclesState((currState) => ({
			...currState,
			isLoading: true,
			fadeIn: true
		}));
	};

	const startFadeOut = (callback) => {
		if (!isMounted.current) return;
		setVehiclesState((currState) => ({
			...currState,
			fadeIn: false
		}));
		// we need to wait to let the fade out animation to
		// be completed
		fadeOutTimeout.current = setTimeout(() => {
			if (!isMounted.current) return;
			callback();
			setVehiclesState((currState) => ({
				...currState,
				isLoading: false
			}));
		}, 300);
	};

	const startCollapse = () => {
		collapseTimeout.current = setTimeout(() => {
			if (!isMounted.current) return;
			// If we set collapse as true, means that something
			// went wrong and we need to collapse the widget,
			// but we need to wait a while to do it
			setVehiclesState((currState) => ({
				...currState,
				fadeIn: false,
				collapse: true,
				isLoading: false
			}));
		}, 1000);
	};

	return [vehiclesState, startFadeIn, startFadeOut, startCollapse];
};
